import { render, staticRenderFns } from "./_base-section.vue?vue&type=template&id=99f10c4a&scoped=true"
import script from "./_base-section.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-section.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-section.vue?vue&type=style&index=0&id=99f10c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f10c4a",
  null
  
)

export default component.exports